'use strict';

window.unRestrictedVideo = !Modernizr.touchevents;

module.exports = (function() { 
    if (unRestrictedVideo) {
        $(".module-video .video-control").show();
    }
    setupVideoModules();
})();

window.onYouTubeIframeAPIReady = function() {
	
	for (var i = 0; i < YTVideos.length; i++) {
		// set the unMute volume to the init volume, unless it is 0, default to 50
		var unMuteVolume = $(YTVideos[i]).data("init-volume") == 0 ? 50 : $(YTVideos[i]).data("init-volume");
		var bInactivityHideCtrls = false;
		// Init player
		YTVideos[i].player = new YT.Player("VideoIframe_"+$(YTVideos[i]).data("video-uuid"), {
			playerVars: {
				rel: 0,
				controls: parseInt($(YTVideos[i]).data("show-yt-controls")),
				wmode: 'opaque',
				modestbranding: 1,
				start: parseInt($(YTVideos[i]).data("video-start")),
				end: parseInt($(YTVideos[i]).data("video-end")),
				disablekb: parseInt($(YTVideos[i]).data("disable-hotkeys"))
			},
			videoId: $(YTVideos[i]).data("video-id"),
			events: {
			    'onReady': onPlayerReady,
			    'onStateChange': onPlayerStateChange
			}
		});
		
		if ($(YTVideos[i]).data("full-width")) {
    		//Dynamicly set the top value of titles and refresh on window resize
			AddDelayedEventTrigger(500, 'resize', RefreshTitlePosition, [YTVideos[i]]);
		} else {
    		//Pause video if we hide it and was played
			$(YTVideos[i]).find('.close').click({index : i}, function(event) {
				var i = event.data.index;
    		 	if (YTVideos[i].player.getPlayerState() != 5) { // 5 = video cued
    		 		YTVideos[i].player.pauseVideo();
    		 	}
    		});
			
			// Trigger the play button (show video) in order to view the video in autoplay
			if(unRestrictedVideo && $(YTVideos[i]).data("auto-play")) { 
    			$(YTVideos[i]).find('.play').trigger("click");
			}
		}
		
		// Mobiles does not have custom play/volume buttons
		
		if (unRestrictedVideo && $(YTVideos[i]).data("ctrl-type") == 'CustomCtrls') {			
    		$(YTVideos[i]).find("#custom-play").click(function(event) {
    			var videoParent = $(this).closest(".module-video")[0];
    			switch (videoParent.player.getPlayerState()) {
    				case 1: // playing
    					videoParent.player.pauseVideo();
    				break;
    				case 2: // paused
    				case 5: // video cued
    					videoParent.player.playVideo();
    				break;
    			}
    		});
    		
    		$(YTVideos[i]).find('#custom-volume').click(function(event) {
    			var videoParent = $(this).closest(".module-video")[0];
    			var volume = videoParent.player.getVolume();
    			
    			if (volume == 0) {
    				volume = unMuteVolume;
    			} else {
    				unMuteVolume = volume;
    				volume = 0;
    			}
    			videoParent.player.setVolume(volume);
    			manageVolumeIcon(videoParent, volume);
    		});
		}
	}
	
	// Find all YouTube videos
	var $allVideos = $("iframe[src^='http://www.youtube.com']"),

    // The element that is fluid width
    $fluidEl = $("body");

	// Figure out and save aspect ratio for each video
	$allVideos.each(function() {

		$(this)
			.data('aspectRatio', this.height / this.width)
			
			// and remove the hard coded width/height
			.removeAttr('height')
			.removeAttr('width');

	});

	// When the window is resized
	// (You'll probably want to debounce this)
	AddDelayedEventTrigger(1000, 'resize', function() {

		var newWidth = $fluidEl.width();
		
		// Resize all videos according to their own aspect ratio
		$allVideos.each(function() {

			var $el = $(this);
			$el
				.width(newWidth)
				.height(newWidth * $el.data('aspectRatio'));

		});
	});
};

function setupVideoModules() {
    $('.module-video').find('.play').click(function() {
        toggleVideoItems($(this));
    });

    $('.module-video').find('.close').click(function() {
        toggleVideoItems($(this));
    }); 
    
    // Store all videos in the window scope
    window.YTVideos = [];
    YTVideos = $("[data-video-uuid]");

	// This code loads the IFrame Player API code asynchronously.
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function onPlayerStateChange(event) {
	var videoParent = $(event.target.getIframe()).closest(".module-video");
	switch (event.data) {
		case YT.PlayerState.ENDED:
			if ($(videoParent).data("video-loop")) {
				event.target.seekTo(parseInt($(videoParent).data("video-start")), true);
				switchClass(videoParent, "play", 0);
			} else if ($(videoParent).data("hide-title-on-play")){
				$(videoParent).find('.grid-x').fadeIn();
			}
		break;
		case YT.PlayerState.PLAYING:
			if ($(videoParent).data("hide-title-on-play")) {
				$(videoParent).find('.grid-x').fadeOut();
			}
			switchClass(videoParent, "play", 0);
		break;
		case YT.PlayerState.PAUSED:
			if ($(videoParent).data("hide-title-on-play")) {
				$(videoParent).find('.grid-x').fadeIn();
			}
			switchClass(videoParent, "play", 1);
		break;
	}
}

// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
	var videoParent = $(event.target.getIframe()).closest(".module-video");
	
	// most modern mobiles cannot autoplay
	if (unRestrictedVideo) {
		// Start with unMuted volume.  It will be muted again if init-volume = 0
		event.target.unMute();
		event.target.setVolume($(videoParent).data("init-volume"));
		if ($(videoParent).data("auto-play")) {
			event.target.playVideo();
		}
	}

	// most modern mobiles cannot change volume and the play/pause button is sometimes ignored
	if (unRestrictedVideo && $(videoParent).data("ctrl-type") == 'CustomCtrls') {
		// Youtube's API does not allow for volume events and we cannot listen to key press events in the iframe.
		setInterval(
			function() {
				manageVolumeIcon(videoParent, event.target.getVolume());
			}
		, 1000);
	}
	$(videoParent).find('.fullWidthBG').fadeOut(1200);
}

function manageVolumeIcon(selector, volume) {
	if (volume == 0) {
		switchClass(selector, "volume", 1);
	} else {
		switchClass(selector, "volume", 0);
	}
}

function switchClass(selector, type, state) {
	var buttonStateClass = {
			"play": ["icon-pause", "icon-play"],
			"volume": ["icon-volume", "icon-volume-none"]
		}
	// Clear all classes
	for(var i = 0;i < buttonStateClass[type].length; i++) {
		$(selector).find("#custom-"+type).removeClass(buttonStateClass[type][i]);
	}
	// Enable class passed in the params
	$(selector).find("#custom-"+type).addClass(buttonStateClass[type][state]);
}

function RefreshTitlePosition(target) {
	var TitleHeight = $(target).find('.grid-x').height();
	var ContainerHeight = $(target).height();

	$(target).find('.grid-x').css("top",function(index) {
		// (container * %) - (title * %)  that way, the title will not overlap under the container.
		return ContainerHeight * ($(target).data("vertical-align")/100) - (TitleHeight * ($(target).data("vertical-align")/100)) + "px";
	});
	
	// Show the title after moving it
	$(target).find('.grid-x').removeClass("hide");
}

function toggleVideoItems(el) {
    $(el).parents('.module-video').find('.play').toggle();
    $(el).parents('.module-video').find('.close').toggleClass('show hide');
    $(el).parents('.module-video').find('.flex-video').toggleClass('active');
}